import Icon from '@sendsprint/ui-react/dist/components/Icon';
import Text from '@sendsprint/ui-react/dist/components/Text';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import cs from 'classnames';
import SuspenseWrapper from '@src/components/suspenseWrapper';
import Skeleton from '@sendsprint/ui-react/dist/components/Skeleton';

export interface LinkItemProps {
  to: string;
  label: string;
  icon: React.LazyExoticComponent<(props: React.SVGProps<SVGSVGElement>) => JSX.Element>;
  active: boolean;
  ComponentToPreloadName?: string;
  client?: 'receiver' | 'sender';
  tourIdentifier?: string;
  showItem?: boolean;
  onLinkClick?: () => void;
}

const LinkItem = ({
  icon,
  label,
  to,
  active,
  ComponentToPreloadName,
  client,
  tourIdentifier,
  showItem = true,
  onLinkClick
}: LinkItemProps) => {
  const [isHovered, setIsHovered] = useState(false);

  if (!showItem) return <></>;

  const handleMouseEnter = () => {
    setIsHovered(true);

    try {
      if (ComponentToPreloadName) {
        if (client === 'receiver') {
          import('@src/navigations/subRoutes/receiverRoutes2').then((module) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (module as any)[ComponentToPreloadName].preload();
          });
        }
        if (client === 'sender') {
          import('@src/navigations/subRoutes/senderRoutes2').then((module) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (module as any)[ComponentToPreloadName].preload();
          });
        }
      }
      // eslint-disable-next-line no-empty
    } catch (error) {}
  };
  return (
    <Link
      onClick={onLinkClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsHovered(false)}
      to={to}
      id={tourIdentifier}
      className={cs(
        'ss-flex ss-items-center ss-duration-200 focus:ss-focus-ring ss-gap-2 ss-py-3 ss-pr-4 ss-rounded-full',
        {
          'ss-opacity-100': isHovered || active,
          'ss-opacity-40': !(isHovered || active)
        }
      )}>
      <SuspenseWrapper
        suspenseFallback={<Skeleton className="ss-w-6 ss-h-3 ss-rounded" />}
        returnNullErrorFallback>
        <Icon
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          svg={icon as any}
          size={24}
          className={cs({
            'ss-text-neutral-400': !isHovered,
            'ss-text-primary1-500': isHovered
          })}
        />
      </SuspenseWrapper>
      <Text
        className={cs('ss-font-medium ss-inline-block md:ss-inline-block lg:ss-inline-block', {
          'ss-text-neutral-400': !isHovered,
          'ss-text-primary1-500': isHovered
        })}>
        {label}
      </Text>
    </Link>
  );
};

export default LinkItem;
